import { defineStore } from "pinia";

import { SurveyService } from "@core/services";
import {
  ACTION_SURVEY_GET_AMOUNT,
  ACTION_SURVEY_GET_EXTRA_SCHEDULES,
  ACTION_SURVEY_GET_EXTRA_REVIEWS,
  GETTER_SURVEY_GET_AMOUNT,
  GETTER_SURVEY_GET_EXTRA_SCHEDULES,
  GETTER_SURVEY_GET_EXTRA_REVIEWS,
} from "@etab/stores/types";
import { ReviewExtraModel, ReviewAmountModel, ScheduleExtraModel } from "@core/models";

export const useSurveyStore = defineStore("survey", {
  // convert to a function
  state: () => ({
    amount: {},
    extraSchedules: [],
    extraReviews: [],
  }),
  getters: {
    [GETTER_SURVEY_GET_AMOUNT]: (state) => new ReviewAmountModel(state.amount),
    [GETTER_SURVEY_GET_EXTRA_SCHEDULES]: (state) => state.extraSchedules.map((schedule) => new ScheduleExtraModel(schedule)),
    [GETTER_SURVEY_GET_EXTRA_REVIEWS]: (state) => state.extraReviews.map((review) => new ReviewExtraModel(review)),
  },
  actions: {
    async [ACTION_SURVEY_GET_AMOUNT]() {
      const amount = await SurveyService.getSurveyAmount();
      this.amount = amount;
      return Promise.resolve();
    },
    async [ACTION_SURVEY_GET_EXTRA_SCHEDULES]() {
      const surveys = await SurveyService.getExtraShedules();
      this.extraSchedules = surveys;
      return Promise.resolve();
    },
    async [ACTION_SURVEY_GET_EXTRA_REVIEWS]() {
      const notes = await SurveyService.getExtraReviews();
      this.extraReviews = notes;
      return Promise.resolve();
    },
    // easily reset state using `$reset`
    clearSurveyStore() {
      this.$reset();
    },
  },
});
